/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { AddressCtsm } from '../models/AddressCtsm';
import type { ClinTrakStudySiteViewModel } from '../models/ClinTrakStudySiteViewModel';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class SiteClinTrakDataService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param studyId
     * @returns ClinTrakStudySiteViewModel
     * @throws ApiError
     */
    public siteClinTrakDataGetPendingSitesByStudyId(
        studyId: number,
    ): Observable<Array<ClinTrakStudySiteViewModel>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/sites/{studyId}',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studySiteId
     * @returns AddressCtsm
     * @throws ApiError
     */
    public siteClinTrakDataGetStudySiteAddress(
        studySiteId: string,
    ): Observable<AddressCtsm> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/sites/address/{studySiteId}',
            path: {
                'studySiteId': studySiteId,
            },
        });
    }
    /**
     * @param pcsSiteId
     * @returns ClinTrakStudySiteViewModel
     * @throws ApiError
     */
    public siteClinTrakDataGetClinTrakStudySiteDataByPcsSiteId(
        pcsSiteId: number,
    ): Observable<ClinTrakStudySiteViewModel> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/sites/pcs/{pcsSiteId}',
            path: {
                'pcsSiteId': pcsSiteId,
            },
        });
    }
}
